import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ShellState {
  /** Celular: folha "Mais" com a navegação completa (também aberta pelo botão "Abrir menu"). */
  menuOpen: boolean;
  setMenuOpen: (v: boolean) => void;
  /** Desktop: menu lateral recolhido em trilho de ícones (preferência do aparelho). */
  collapsed: boolean;
  setCollapsed: (v: boolean) => void;
  toggleCollapsed: () => void;
  /** Paleta de comandos (Ctrl/Cmd + K). */
  paletteOpen: boolean;
  setPaletteOpen: (v: boolean) => void;
}

/** Estado do shell (menu, trilho recolhido e paleta). Só `collapsed` fica salvo no aparelho. */
export const useShell = create<ShellState>()(
  persist(
    (set) => ({
      menuOpen: false,
      setMenuOpen: (menuOpen) => set({ menuOpen }),
      collapsed: false,
      setCollapsed: (collapsed) => set({ collapsed }),
      toggleCollapsed: () => set((s) => ({ collapsed: !s.collapsed })),
      paletteOpen: false,
      setPaletteOpen: (paletteOpen) => set({ paletteOpen }),
    }),
    { name: 'dz.shell', partialize: (s) => ({ collapsed: s.collapsed }) },
  ),
);
